(function () {
  'use strict';

  document.querySelectorAll('[data-ugc]').forEach(function (root) {
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-ugc-tile]'));

    function pauseTile(tile) {
      var video = tile.querySelector('video');
      if (video) video.pause();
      tile.classList.remove('is-playing');
    }

    tiles.forEach(function (tile) {
      var toggle = tile.querySelector('[data-ugc-toggle]');
      var video = tile.querySelector('video');
      if (!toggle || !video) return;

      // Clicking a tile with the video already playing pauses it, and the
      // cover comes back so it reads as "tap to play" again.
      toggle.addEventListener('click', function () {
        if (tile.classList.contains('is-playing')) {
          pauseTile(tile);
          return;
        }

        // One clip at a time.
        tiles.forEach(function (other) {
          if (other !== tile) pauseTile(other);
        });

        tile.classList.add('is-playing');
        var started = video.play();
        if (started && started.catch) started.catch(function () { tile.classList.remove('is-playing'); });
      });

      video.addEventListener('ended', function () { tile.classList.remove('is-playing'); });
    });
  });
})();
